//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import debounce from 'lodash/debounce'
import { FocusTrap } from 'focus-trap-vue'
import WCAG from '@/scripts/libs/wcag/wcag'

// TODO: detach panel from "pdp" logic and create base side panel
import { PANEL_Z_INDEX } from '@/scripts/constants/panel'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { EVENTS } from '@/scripts/constants/css-classes'

export default {
  name: 'rb-panel',
  components: {
    FocusTrap,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    canShowHeader: {
      type: Boolean,
      default: true,
    },
    openDirection: {
      type: String,
      default: 'right',
    },
    disabledCloseButton: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      closePanel: () => this.close(),
    }
  },
  data() {
    return {
      windowInnerHeight: window.innerHeight,
      showContent: false,
      panelZIndex: PANEL_Z_INDEX,
    }
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    scrollIsLocked() {
      return this.visible
    },
  },
  watch: {
    windowInnerHeight() {
      this.updateVhMainCssVariable()
    },
    visible(value) {
      this.showContent = value
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(EVENTS.RESIZE, debounce(this.updateWindowInnerHeight, 30))
      document.addEventListener(EVENTS.KEY_DOWN, this.onEsc)
    })
  },
  beforeDestroy() {
    window.removeEventListener(EVENTS.RESIZE, debounce(this.updateWindowInnerHeight, 30))
    document.removeEventListener(EVENTS.KEY_DOWN, this.onEsc)
  },
  methods: {
    onEsc(e) {
      if (WCAG.isEscPressed(e)) {
        this.close()
      }
    },
    afterEnterMainPanel() {
      this.updateVhMainCssVariable()
      disableBodyScroll(this.$refs.contentElement, {
        reserveScrollBarGap: true,
      })
    },
    updateWindowInnerHeight() {
      if (this.visible) {
        this.windowInnerHeight = window.innerHeight
      }
    },
    close() {
      enableBodyScroll(this.$refs.contentElement)
      this.$emit('closed')
    },
    focus() {
      if (this.canShowHeader) {
        this.$refs.closeButton.focus()
        return
      }
      this.$refs.contentElement.focus()
    },
    updateVhMainCssVariable() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vhmain', `${vh}px`)
    },
  },
}
